export const fetchAllPaginatedRows = async ({
  fetchPage,
  getRows = (response) => response?.data,
  getTotalPages = (response) => Number(response?.pagination?.totalPages || 1),
  transformRows
}) => {
  let currentPage = 1;
  let totalPages = 1;
  const rows = [];

  while (currentPage <= totalPages) {
    const response = await fetchPage(currentPage);
    const pageRows = Array.isArray(getRows(response)) ? getRows(response) : [];
    rows.push(...(typeof transformRows === 'function' ? transformRows(pageRows, response) : pageRows));
    totalPages = getTotalPages(response);
    currentPage += 1;
  }

  return rows;
};